import React from "react";
import "../styles/Blog.css";
import BlogCard from "./BlogCard";

// Datos de ejemplo del blog, más adelante se puede cargar desde Firebase o API
const blogPosts = [
  {
    id: 1,
    title: "Cómo equilibrar tus energías",
    summary: "Aprende técnicas ancestrales de limpieza energética y armonización.",
    image: "/images/blog1.jpg",
    link: "/blog/como-equilibrar-tus-energias"
  },
  
];

const Blog = () => {
  return (
    <section className="blog-section">
      <h1 className="blog-title">Nuestro Blog</h1>
      <p className="blog-subtitle">Artículos, consejos y espiritualidad</p>
      <div className="blog-grid">
        {blogPosts.map(post => (
          <BlogCard key={post.id} post={post} />
        ))}
      </div>
    </section>
  );
};

export default Blog;